export default __webpack_public_path__ + "static/media/crispo-logo.c62c37e8.png";